module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMCA1NC44NTdoMzYuNTcxVjEyOEgwVjU0Ljg1N3pNOTEuNDI5IDI3LjQzSDEyOFYxMjhIOTEuNDI5VjI3LjQyOXpNNDUuNzE0IDBoMzYuNTcydjEyOEg0NS43MTRWMHoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/chart.svg
// module id = RjYk
// module chunks = 12